module.exports = __webpack_public_path__ + "static/media/13.75d0f941.jpg";